import queryClient from '../../../ReactQuery/client';
import useMutation from '../../../ReactQuery/useMutation';
import { patch } from '../../../redux/api';
import type { LicensingRule, PolicyId } from '../../../types';

type UpdatePolicyRulesRequest = {
  editedRuleId: number;
  editedRule: Partial<LicensingRule>;
};

type UpdatePolicyRulesParams = {
  policyId: PolicyId;
  rules: UpdatePolicyRulesRequest[];
};

const patchPolicyRules = ({ policyId, rules }: UpdatePolicyRulesParams) => {
  return patch<{ newRules: UpdatePolicyRulesRequest[] }>(`/api/policies/${policyId}/rules`, { newRules: rules });
};

/**
 * hook for editing multiple licensing policy rules
 */
export default function useUpdatePolicyRules() {
  return useMutation<UpdatePolicyRulesParams>({
    mutationFn: (params) => patchPolicyRules(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy'] });
    },
  });
}
